/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:35:21
 * @LastEditTime: 2022-01-26 22:27:34
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 合同详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/RentContractDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import { fetchZJBSyncDataRentContractInfo } from '../../../services/ZJBSyncDataRecord'
import { commonIsMap, contractType, credentialType, customerType, dicContractSource, dicRentContractFirstLastRentType, dicRentContractRentStatus, dicRentContractSettlementStatus, mapZJBSyncDataDetailType } from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';


const RentContractDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '起租日', dataIndex: 'beginDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '到期日', dataIndex: 'endDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '帐单生成日', dataIndex: 'billBeginDate',width: 110,  render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '小区楼栋', dataIndex: 'buildingName', width: 250,  },

        { title: '合同编号', dataIndex: 'contractNo', width: 250,  },
        { title: '合同备注', dataIndex: 'contractRemark', width: 250,  },
        { title: '合同来源', dataIndex: 'contractSource', width: 150, render: (text) => {
            return findDict(dicContractSource, text).title
        }},
        { title: '合同类型', dataIndex: 'contractType', width: 150, render: (text) => {
            return findDict(contractType, text).title
        }},
        { title: '创建电子合同', dataIndex: 'createElectronicContract', width: 150, render: (text) => text ? '是'  : '否'},
        { title: '办理人', dataIndex: 'createMerchantUserName',width: 150,  },
        
        { title: '证件类别', dataIndex: 'customerCredentialType',width: 150,  render: (text) => {
            return findDict(credentialType, text).title
        }},
        { title: '租客证件号', dataIndex: 'customerIdNumber', width: 150, },
        { title: '租客名称', dataIndex: 'customerName',width: 150,  },
        { title: '租客电话', dataIndex: 'customerPhone', width: 150, },
        { title: '电子合同', dataIndex: 'customerSigned', width: 110,  render: (text) => text ? '已签约' : '未签约'},
        { title: '租客类别', dataIndex: 'customerType', width: 110, render: (text) => {
            return findDict(customerType, text).title
        }},
        { title: '门卡押金', dataIndex: 'doorCardDeposit', width: 110,  },
        { title: '电表数', dataIndex: 'eletricityMeterNumber', width: 110, },
        { title: '水表数', dataIndex: 'waterMeterNumber', width: 110},
        { title: '退租.结算金额', dataIndex: 'endAmount', width: 150, },
 
        { title: '退租.办理日期', dataIndex: 'endHandleDate', width: 150, render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '退租.办理备注', dataIndex: 'endHandleRemark', width: 150, },
        { title: '退租.退款帐号信息', dataIndex: 'endPayAccount', width: 200, },
        // { title: '退租.退款方式', dataIndex: 'endPayType', render: (text) => {}},
        // { title: '退租.收款方式', dataIndex: 'endReceiveType', render: (text) => {}},
        // { title: '退租.类型', dataIndex: 'endType', render: (text) => {}},
        // { title: '退租.办理人', dataIndex: 'endUserId', render: (text) => {}},
        { title: '实际退租日', dataIndex: 'factEndDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '零散租期类别', dataIndex: 'firstLastRentType', width: 120, render: (text) => {
            return findDict(dicRentContractFirstLastRentType, text).title
        }},
        {title: '零散租期', children: [
            { title: '首期截止日', dataIndex: 'firstRentEndDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
            { title: '首期租金', dataIndex: 'firstRentFee', width: 120, },
            { title: '首期宽带费', dataIndex: 'firstRentNetworkFee', width: 120, },
            { title: '首期物业费', dataIndex: 'firstRentPropertyFee', width: 120, },
            { title: '首期起始日', dataIndex: 'firstRentStartDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
            { title: '末期截止日', dataIndex: 'lastRentEndDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
            { title: '末期租金', dataIndex: 'lastRentFee', width: 120, },
            { title: '末期宽带费', dataIndex: 'lastRentNetworkFee', width: 120, },
            { title: '末期物业费', dataIndex: 'lastRentPropertyFee', width: 120, },
            { title: '末期起始日', dataIndex: 'lastRentStartDate', width: 110, render: (text) => formatTime(text, 'YYYY-MM-DD')},
        ]},
        { title: '建融公寓唯一合同编号', dataIndex: 'jrContractId', },
        { title: '联系人', dataIndex: 'linkmanName', width: 120, },
        { title: '联系人手机', dataIndex: 'linkmanPhone', width: 120, },
        { title: '商户名称', dataIndex: 'merchantName', width: 220, },
        { title: '商户是否已签电子合同', dataIndex: 'merchantSigned', render: (text) => text ? '是' : '否'},
        { title: '租金', dataIndex: 'monthlyFee', },
        { title: '宽带费', dataIndex: 'networkFee', },
        { title: '常规押金', dataIndex: 'normalDeposit', },
        { title: '常规押金月数', dataIndex: 'normalDepositMonths', },
        { title: '逾期天数', dataIndex: 'overdueDays', },
        { title: '付款日', dataIndex: 'payDay', },
        { title: '项目名称', dataIndex: 'projectName', },
        { title: '物业费', dataIndex: 'propertyFee', },
        { title: '办理备注', dataIndex: 'remark', },
        { title: '合同列表总金额', dataIndex: 'rentContractTotalMoney', },
        { title: '合同列表总条数', dataIndex: 'rentContractTotalNum', },
        { title: '租赁状态', dataIndex: 'rentStatus', render: (text) => {
            return findDict(dicRentContractRentStatus, text).title
        }},
        { title: '房间号', dataIndex: 'roomNo', },
        { title: '结算状态', dataIndex: 'settlementStatus', render: (text) => {
            return findDict(dicRentContractSettlementStatus, text).title
        }},
        { title: '商户简称', dataIndex: 'shortName', },
        { title: '办理日期', dataIndex: 'signDate', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '签约状态', dataIndex: 'signStatus', render: (text) => {
            return text === 2 ? '已签'  : '未签'
        }},
        { title: '当天短信发送状态', dataIndex: 'smsLogStaus', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
       
        { title: '更新时间', dataIndex: 'updateTime', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime},
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="合同详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper bordered initialValue={defaultSearch} columns={columns} searchOptions={searchOptions} scroll={{x:9000}} request={fetchZJBSyncDataRentContractInfo} />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(RentContractDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/RentContractDetailListModal.jsx